<template>
  <section id="booking-container" class="ancre">
    <div class="booking">
      <h2
        class="title-section"
        data-aos="fade-up"
        data-aos-delay="50"
        data-aos-duration="1000"
      >
        Prendre un rendez-vous
      </h2>

      <p class="booking-container">
        <!-- En cas de problème d'affichage ci-dessous, cliquez sur ce lien pour
        prendre rendez-vous :
        <a
          href="https://book.timify.com/?accountId=60a7742a7e4a4c118275bb4d&hideCloseButton=true"
          target="_blank"
        >
          lien de réservation
        </a> -->

        Lors de mon absence vous pouvez prendre rendez-vous avec ma remplaçante
        Chaix Adélaïde :
        <a
          href="https://book.timify.com/?accountId=686f76ae5e90e035b068b4f2&hideCloseButton=true"
          target="_blank"
        >
          lien de réservation
        </a>
      </p>

      <iframe
        title="Module de réservation"
        width="600"
        height="400"
        src="https://book.timify.com?accountId=60a7742a7e4a4c118275bb4d&fullscreen=1&hideCloseButton=1&locale=fr-fr"
      ></iframe>
    </div>
  </section>
</template>

<script>
export default {
  name: 'booking',
}
</script>

<style lang="scss">
#booking-container {
  .booking {
    text-align: center;
    margin: 5rem 0;

    .booking-container {
      width: 80%;
      margin: 2rem auto 0;
      color: #002e4e;

      a {
        color: #68a0c5;
      }
    }

    iframe {
      margin-top: 3rem;
    }
  }

  @media all and (max-device-width: 768px) {
    .booking {
      margin: 8rem 0 0 0;

      iframe {
        width: 343px;
      }
    }
  }
}
</style>
